import { applyMiddleware, compose, combineReducers, createStore } from 'redux';
import { reducer as exercise } from './routes/SpeechDevelopment/reducers/exercise.js';

const reducers = {
  exercise,
};
const middlewares = [];
const enhancers = [];
let composer = compose;

if (
  process.env.NODE_ENV !== 'production' &&
  typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
) {
  composer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const combined = combineReducers(reducers);
const applied = applyMiddleware(...middlewares);
export const store = createStore(combined, composer(applied, ...enhancers));
